import { useMutation, useQuery } from "@tanstack/react-query";
import { RoleClaimDto } from "../../../../services/dto";
import { IActionResult } from "../../../../assets/utils/lib";
import { RoleClaimClient } from "../../../../services/proxies";
import { LookupDto } from "../../../../assets/utils/lib/lookupDto";
import { Constants } from "../../../../assets/utils/lib/constants";

export namespace RolePermissionService {
  const roleClaimClient = new RoleClaimClient();

  export const save = () =>
    useMutation<IActionResult<RoleClaimDto>, Error, RoleClaimDto>({
      mutationFn: async (payload: RoleClaimDto) => {
        return await roleClaimClient.saveRoleClaimAsync(payload);
      },
    });

  export const getRolePermissionQuery = (roleId: string | undefined) =>
    useQuery({
      queryKey: ["getRolePermissionQuery", roleId],
      queryFn: async () => await roleClaimClient.getRoleClaimsAsync(roleId),
      enabled: Boolean(roleId) && roleId !== Constants.emptyGuid,
      select: (data) => {
        return {
          roleId: data.roleId,
          claim: data.claim?.map((c) => c.id),
        };
      },
    });

  export const getRolePermissionLookupsQuery = () =>
    useQuery({
      queryKey: ["rolePermissionLookupsQuery"],
      queryFn: async () => await roleClaimClient.getLookupsAsync(),
      select: (data) => {
        return {
          permission: data?.permission,
          role: LookupDto.mapToOptions(data?.role),
        };
      },
    });
}
